import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { graphql, Link } from "gatsby"
import { Container, Row, Col } from "react-bootstrap"
import Mainmenu from "../components/mainmenu"
import TopPage from "../components/top-page"
import Posts from "../components/posts"

const BlogPage = ({ data }) => {
  const pageData = data.wordpressPage.acf

  return (
    <Layout pageInfo={{ pageName: "index" }}>
      <SEO title="Blog" keywords={[`halla`, `blog`, `website`]} />

      <TopPage logo={data.logo} bg={data.topPageBg} />

      <Mainmenu />

      <Container className="page-title">
        <Row>
          <Col>
            <h1>Blog</h1>
          </Col>
        </Row>
      </Container>

      <Posts posts={data.allWordpressPost} />

      <Container fluid className="footer">
        <Row>
          <Container>
            <Row>
              <Col className="copyright">
                {pageData.footer_copy}{" "}
                <Link to="legal" title="Legal">
                  Legal
                </Link>
                .
              </Col>
            </Row>
          </Container>
        </Row>
      </Container>
    </Layout>
  )
}

export default BlogPage

export const pageQuery = graphql`
  query {
    logo: file(relativePath: { eq: "logo.png" }) {
      childImageSharp {
        fluid(maxWidth: 500) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    topPageBg: file(relativePath: { eq: "big-slideshow-3.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1920) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }

    wordpressPage(title: { eq: "Homepage" }) {
      acf {
        footer_copy
      }
    }

    allWordpressPost(sort: { order: DESC, fields: date }) {
      edges {
        node {
          title
          excerpt
          date(formatString: "MM/DD/YYYY")
          path
          featured_media {
            localFile {
              childImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid_tracedSVG
                }
              }
            }
          }
          author {
            name
          }
          acf {
            image_for_listing {
              localFile {
                childImageSharp {
                  fluid {
                    ...GatsbyImageSharpFluid_tracedSVG
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
